enum RoleEnum {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_PROJECT_MANAGER = "ROLE_PROJECT_MANAGER",
    ROLE_PROJECT_MODERATOR = "ROLE_PROJECT_MODERATOR",
    ROLE_CONTENT_MANAGER = "ROLE_CONTENT_MANAGER",
    ROLE_PORTAL = "ROLE_PORTAL",
}

export default RoleEnum;
